import React from "react";
import { cn } from "../../utils/lib";

export function BiDirectionalArrowIcon({ className, ...props }) {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      className={cn("", className)}
      {...props}
    >
      <g id="arrow-swap">
        <g id="vuesax/linear/frame">
          <g id="frame">
            <path
              id="Vector"
              d="M1.75 4.505L4.255 1.995"
              stroke="currentColor"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              id="Vector_2"
              d="M10.25 4.505H1.75"
              stroke="currentColor"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              id="Vector_3"
              d="M10.25 7.495L7.745 10.005"
              stroke="currentColor"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              id="Vector_4"
              d="M1.75 7.495H10.25"
              stroke="currentColor"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}
